import { render } from "./AddRegister.vue?vue&type=template&id=d425df3c&scoped=true"
import script from "./AddRegister.vue?vue&type=script&lang=js"
export * from "./AddRegister.vue?vue&type=script&lang=js"

import "./AddRegister.vue?vue&type=style&index=0&id=d425df3c&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d425df3c"],['__file',"resources/js/pages/registrePresence/AddRegister.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d425df3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d425df3c', __exports__)) {
    console.log('reload')
    api.reload('d425df3c', __exports__)
  }
  
  module.hot.accept("./AddRegister.vue?vue&type=template&id=d425df3c&scoped=true", () => {
    console.log('re-render')
    api.rerender('d425df3c', render)
  })

}


export default __exports__